export const VimeoTools = ()=>{

}

export const getVimeoOembed = async (videoId) =>{
    const res = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}&responsive=1`)
    return await res.json()
}
